// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__KQh4i","title":"ClientInsurance_title__1kcMq","itemText":"ClientInsurance_itemText__2YZ9B"};